import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.datahaulReports, action) => {
  switch (action.type) {
    case types.GET_DATAHAUL_REPORTS:
      return {
        ...state,
        datahaulReports: action.payload.map(
          ({ id, runDate, status, title, type }) => ({
            id,
            runDate,
            status,
            title,
            type,
            progress: status === 'Complete' ? 100 : 0,
          }),
        ),
        isAnyReportInProgress: action.payload.some(
          ({ status }) => status === 'Processing',
        ),
      };
    case types.UPDATE_DATAHAUL_REPORTS: {
      const repObj = {
        id: action.payload.reportId,
        progress: action.payload.status,
        runDate: action.runDate,
        status: action.payload.status === 0 ? 'Submitted' : 'Completed',
        title: action.title,
        type: action.reportFormat,
      };
      return {
        ...state,
        datahaulReports: [...state.datahaulReports, repObj],
        isAnyReportInProgress: true,
        datahaulSelectedWeight: action.selectedWeight,
      };
    }
    case types.RENAME_DATAHAUL_REPORT:
      return {
        ...state,
        datahaulReports: state.datahaulReports.map(datahaulReport => ({
          ...datahaulReport,
          title:
            datahaulReport.id === action.reportID
              ? action.title
              : datahaulReport.title,
        })),
      };
    case types.DELETE_DATAHAUL_REPORT:
      return {
        ...state,
        datahaulReports: state.datahaulReports.filter(
          ({ id }) => id !== action.reportID,
        ),
      };
    default:
      return state;
  }
}
